import React from 'react';
import { ShieldCheck, ShieldAlert, ShieldX, Loader2, ShieldQuestion } from 'lucide-react';

export const VERDICT = {
  clean: { label: 'Clean', icon: ShieldCheck, pill: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/30', ring: '#059669' },
  review: { label: 'Review', icon: ShieldAlert, pill: 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/30', ring: '#D97706' },
  high_risk: { label: 'High Risk', icon: ShieldX, pill: 'bg-red-500/10 text-red-700 dark:text-red-400 border-red-500/30', ring: '#DC2626' },
  running: { label: 'Scanning', icon: Loader2, pill: 'bg-indigo-500/10 text-indigo-700 dark:text-indigo-300 border-indigo-500/30', ring: '#4F46E5' },
  failed: { label: 'Failed', icon: ShieldQuestion, pill: 'bg-muted text-muted-foreground border-border', ring: '#94A3B8' },
};

export const verdictKey = (scan) => (scan.status === 'running' || scan.verdict === 'scanning' ? 'running' : scan.status === 'failed' ? 'failed' : scan.verdict);

export const VerdictBadge = ({ verdict, score, size = 'sm', testid }) => {
  const v = VERDICT[verdict] || VERDICT.failed;
  const Icon = v.icon;
  const big = size === 'lg';
  return (
    <span className={`inline-flex items-center gap-1.5 border rounded-full font-semibold whitespace-nowrap ${v.pill} ${big ? 'px-3.5 py-1.5 text-sm' : 'px-2 py-0.5 text-[11px]'}`} data-testid={testid}>
      <Icon className={`${big ? 'h-4 w-4' : 'h-3.5 w-3.5'} ${verdict === 'running' ? 'animate-spin' : ''}`} />
      {v.label}{score != null && verdict !== 'running' ? ` · ${score}` : ''}
    </span>
  );
};

export const TrustRing = ({ score, verdict, testid }) => {
  const r = 46;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, score || 0)) / 100;
  const color = (VERDICT[verdict] || VERDICT.failed).ring;
  return (
    <div className="relative w-32 h-32 shrink-0" data-testid={testid}>
      <svg viewBox="0 0 110 110" className="w-full h-full -rotate-90">
        <circle cx="55" cy="55" r={r} fill="none" stroke="currentColor" strokeWidth="9" className="text-muted/60" />
        <circle cx="55" cy="55" r={r} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - pct)} style={{ transition: 'stroke-dashoffset 900ms cubic-bezier(.2,.8,.2,1)' }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-3xl font-extrabold tabular-nums" style={{ fontFamily: 'Manrope, sans-serif', color }}>{score ?? '—'}</span>
        <span className="text-[10px] uppercase tracking-widest text-muted-foreground font-semibold">Trust score</span>
      </div>
    </div>
  );
};
